function initSyncedAutoplay(grid) {
  var videos = Array.prototype.slice.call(grid.querySelectorAll('video'));
  var shouldAutoplay = grid.dataset.autoplay === 'true';
  if (!shouldAutoplay || !videos.length) return;

  var started = false;

  function whenReady(video) {
    return new Promise(function (resolve) {
      if (video.readyState >= 3) {
        resolve();
        return;
      }
      var onCanPlay = function () {
        video.removeEventListener('canplay', onCanPlay);
        resolve();
      };
      video.addEventListener('canplay', onCanPlay);
      // Safety net: don't let one slow video hold the others back forever.
      setTimeout(resolve, 2000);
    });
  }

  function playAllTogether() {
    if (started) return;
    started = true;

    videos.forEach(function (video) {
      // Preload was intentionally left off until now, to avoid
      // downloading off-screen videos before they're needed.
      video.preload = 'auto';
      video.load();
    });

    Promise.all(videos.map(whenReady)).then(function () {
      videos.forEach(function (video) {
        video.play().catch(function () {
          // Autoplay can still be blocked (e.g. muted setting off,
          // low-power mode); fail silently and leave controls usable.
        });
      });
    });
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            playAllTogether();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.25 }
    );
    observer.observe(grid);
  } else {
    playAllTogether();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-video-grid]').forEach(initSyncedAutoplay);

  var items = document.querySelectorAll('[data-video-item]');

  items.forEach(function (item) {
    var video = item.querySelector('video');
    var playPauseBtn = item.querySelector('[data-video-playpause]');
    var muteBtn = item.querySelector('[data-video-mute]');

    if (!video) return;

    function syncPlayPauseIcon() {
      if (!playPauseBtn) return;
      var iconPause = playPauseBtn.querySelector('.icon-pause');
      var iconPlay = playPauseBtn.querySelector('.icon-play');
      var isPaused = video.paused || video.ended;

      if (iconPause) iconPause.hidden = isPaused;
      if (iconPlay) iconPlay.hidden = !isPaused;

      playPauseBtn.setAttribute(
        'aria-label',
        isPaused ? 'Play video' : 'Pause video'
      );
    }

    function syncMuteIcon() {
      if (!muteBtn) return;
      var iconMuted = muteBtn.querySelector('.icon-muted');
      var iconUnmuted = muteBtn.querySelector('.icon-unmuted');

      if (iconMuted) iconMuted.hidden = !video.muted;
      if (iconUnmuted) iconUnmuted.hidden = video.muted;

      muteBtn.setAttribute(
        'aria-label',
        video.muted ? 'Unmute video' : 'Mute video'
      );
    }

    if (playPauseBtn) {
      playPauseBtn.addEventListener('click', function () {
        if (video.paused || video.ended) {
          video.play();
        } else {
          video.pause();
        }
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        if (!video.muted && video.paused) {
          video.play();
        }
      });
    }

    video.addEventListener('play', syncPlayPauseIcon);
    video.addEventListener('pause', syncPlayPauseIcon);
    video.addEventListener('volumechange', syncMuteIcon);

    syncPlayPauseIcon();
    syncMuteIcon();
  });
});
